import * as ANIMATION from './animations';

export const ANIMATION_CONFIGS = {
  [ANIMATION.ANIMATION_FUSION]: {
    middle: 'fusion-core-come-back',
    end: 'fusion-core-out',
  },

  [ANIMATION.ANIMATION_NEW]: {
    start: 'background-in',
    end: 'background-out',
    hideContent: 'hide-popup-content',
    showContent: 'hide-popup-content-timer',

    baseShow: 'item-unlocked-show',
    baseHide: 'item-unlocked-hide',
  },

  [ANIMATION.ANIMATION_FINAL]: {
    delete: 'dematerialize-core-in',
    end: 'dematerialize-timer',
    encyclopedia: 'materialize-core-out',
    encyclopediaId: 'animation-final-encyclopedia',
  },

  [ANIMATION.ANIMATION_CLEAR]: {
    transitionMiddle: 'transform',
    revertMiddle: 'opacity',
  },

  [ANIMATION.ANIMATION_GAME_END]: {
    end: 'ending-hide',
  },

  [ANIMATION.ANIMATION_GAME_COMPLETION]: {
    middle: 'cover-show',
    end: 'completion-hide',
  },
};
